<template>
  <div class="campaign-progress">
    <div class="product-link-top">
      Campaign Budget Progress
    </div>
    <a-spin tip="Loading..." :spinning="loading">
    <div class="campaign-progress-content">
      <div class="progress-track">
        <div class="progress-segment your-earn" :style="{ width: `${progress.percentByYou}%` }">
          <span class="segment-tag">{{ progress.percentByYou }}%</span>
        </div>
        <div class="progress-segment publishers-earn" :style="{ width: `${progress.percentByAllPublishers}%` }">
          <span class="segment-tag ">{{ progress.percentByAllPublishers }}%</span>
        </div>
        <div class="progress-segment budget-remains" :style="{ width: `${progress.percentRemaining}%` }">
          <span class="segment-tag" style="color: rgba(15, 6, 41, 0.9);">{{ progress.percentRemaining }}%</span>
        </div>
      </div>

      <div class="progress-summary">
        <div class="summary-card">
          <div class="summary-dot your-earn-dot"></div>
          <div class="summary-content">
            <div class="summary-title">
              <span>You Earn</span>
            </div>
            <div class="summary-value">{{ progress.currencySymbol }} {{ progress.yourEarnings }}</div>
          </div>
        </div>
        <div class="summary-card">
          <div class="summary-dot publishers-earn-dot"></div>
          <div class="summary-content">
            <div class="summary-title">
              <span>All Publishers Earn</span>
            </div>
            <div class="summary-value">{{ progress.currencySymbol }} {{ progress.allPublishersEarnings }}</div>
          </div>
        </div>
        <div class="summary-card">
          <div class="summary-dot budget-remains-dot"></div>
          <div class="summary-content">
            <div class="summary-title">
              <span>Budget Remains</span>
            </div>
            <div class="summary-value">{{ progress.currencySymbol }} {{ progress.budgetRemaining }}</div>
          </div>
        </div>


      </div>
    </div>
    </a-spin>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import { cpcCampaignsApi } from '~/server'
import { useRoute } from 'vue-router'
const route = useRoute()
const campaignId = route.params.id
const progress = ref({})
const loading = ref(true)

const getCampaignProgress = async () => {
  const { data } = await cpcCampaignsApi.getJoinedReportingDetail({ campaignId: campaignId })
  progress.value = data
  loading.value = false
}
onMounted(() => {
  getCampaignProgress()
})
</script>
<style scoped lang="less">
.product-link-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: Sora;
  font-weight: 600;
  font-size: 20px;
  padding: 22px 16px;
  letter-spacing: 0.4px;
  color: rgba(15, 6, 41, 1);
  border-bottom: 1px solid rgba(232, 229, 237, 1);
}

.campaign-progress-content {
  padding: 16px;
}

.progress-track {
  display: flex;
  overflow: hidden;
  border-radius: 8px;
  height: 32px;

}

.progress-segment {
  position: relative;
}

.your-earn {
  background: #f5b63f;
  border-radius: 8px;
  z-index: 5;
}

.publishers-earn {
  background: #31b26f;
  border-radius: 8px;
  z-index: 4;
  left: -10px;
}

.budget-remains {
  background: rgba(138, 100, 244, 0.14);
  border-radius: 8px;
  left: -20px;
}

.segment-tag {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 16px;
  color: #ffffff;
  font-family: Sora;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 18px;
  leading-trim: NONE;
  line-height: 24px;
  letter-spacing: 0.4px;

}

.your-earn-tag {
  right: 16px;
  color: #ffffff;
  font-size: 14px;
}

.publishers-earn-tag {
  right: 16px;
  color: #ffffff;
  font-size: 20px;
}

.budget-remains-tag {
  right: 16px;
  color: #3d3359;
  font-size: 22px;
}

.progress-summary {
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.summary-card {
  background: rgba(248, 247, 252, 1);
  border-radius: 8px;
  padding: 13px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.summary-title {
  font-family: Sora;
  font-weight: 500;
  font-style: Medium;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: 0.3px;
  color: rgba(15, 6, 41, 0.6);
}

.summary-dot {
  width: 42px;
  height: 42px;
  border-radius: 8px;
  display: inline-block;
}

.your-earn-dot {
  background: #f5b63f;
}

.publishers-earn-dot {
  background: #31b26f;
}

.budget-remains-dot {
  background: #ddd8ea;
}

.summary-value {
  font-family: Sora;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 18px;
  leading-trim: NONE;
  line-height: 24px;
  letter-spacing: 0.4px;
  color: rgba(15, 6, 41, 1);
}

@media (max-width: 1200px) {
  .progress-summary {
    grid-template-columns: 1fr;
  }

  .summary-value {
    font-size: 22px;
    line-height: 28px;
  }
}
</style>